/* import __COLOCATED_TEMPLATE__ from './whats-new-dropdown-item-survey-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();